
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import router from "@/router";

@Component({
  name: "NuevoPaciente",
})

export default class NuevoPaciente extends Vue {
  @Prop() pacienteEdit!: any
  @Prop() dialog!: boolean
  @Prop() swEditar!: boolean

  private globalStore = globalStore();
  private consultorioStore = useConsultorioStore();
  private consultorioService = consultorioService.getInstance();
  private tab:any = null;
  
  cliente_seleccionado = '';
  pacientes_all = [];
  generos= [{nombre: 'Masculino'}, {nombre:'Femenino'}]
  
  paciente= {
      nombre: '',
      apellidos: '',
      fecha_nacimiento: '',
      genero: '',
      direccion: '',
      telefono: '',
      email: '',
      encargado: '',
      ci: '',
			estado_civil: 'Soltero',
			edad: 0,
			ocupacion: '',
			procedencia: ''
  }
  valid = true;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');
  
  mounted(){
    //this.getTratamientos();
  }
  close(){
    this.$router.push({name: 'pacientes'});
  }
  guardar(){
    if (!this.$refs.form.validate()) {
      Alert.warning( `Lene todos los campos obligatorios (*)`)
        return;
      }
      Alert.confirm(`Se realizará el registro del paciente ${this.paciente.nombre} ${this.paciente.apellidos}`, 'Registrar nueva Paciente?').then(async result => {
        if(result.isConfirmed){
          await this.consultorioService.registrarPaciente(this.paciente).then(response =>{
            this.limpiar()
            router.push({name: 'pacientes'});
          })
        }
      })
    }
  

  limpiar(){
    this.paciente= {
      nombre: '',
      apellidos: '',
      fecha_nacimiento: '',
      genero: '',
      direccion: '',
      telefono: '',
      email: '',
      encargado: '',
      ci: ''
    }
  }
  get loading(): boolean {
    return this.consultorioStore.loading;
  }
}

